/* eslint-disable @typescript-eslint/no-explicit-any -- aligné U3203AiMissionListToolBar */
/* eslint-disable react-hooks/exhaustive-deps -- useMemo sur getSelectedRows() comme U3203 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000GridStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000GridStateHandlers';
import type { U2000TableHandlers } from '../../../u2000Core/types/U2000TableHandlers';
import { NS, U3206ROLES } from '../../U3206';
import type { U3206AiUserGroupSearchRow } from '../../U3206Service';

interface U3206AiUserGroupListToolBarProps {
  gridStateHandlers: U2000GridStateHandlers<U3206AiUserGroupSearchRow>;
  handlerActions?: U2000TableHandlers<U3206AiUserGroupSearchRow>;
}

export const U3206AiUserGroupListToolBar: React.FC<U3206AiUserGroupListToolBarProps> = ({
  gridStateHandlers,
  handlerActions,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();
  const selectedRows = gridStateHandlers.getSelectedRows();

  const disableUpdateBtn = React.useMemo(() => selectedRows.length !== 1, [selectedRows]);
  const disableDeleteBtn = React.useMemo(() => selectedRows.length === 0, [selectedRows]);

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3206ROLES.ADD),
      handleClick: handlerActions?.onAdd,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3206ROLES.EDIT),
      handleClick: handlerActions?.onModify,
      disabled: disableUpdateBtn,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3206ROLES.DELETE),
      handleClick: handlerActions?.onDelete,
      disabled: disableDeleteBtn,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
